import CollapseItem from "../../components/CollapseItem";
import Header from "./components/Header";
import Fields from "./components/Fields";
import { FormBuilder } from "../../../../types/FormBuilderInterfaces";
import { Prefill } from "../../../../types/GlobalInterfaces";
import HiddenFields from "./components/HiddenFields";
import { FormAvailableFields } from "../../FormBuilderDrawer";
import SectionsAndLayouts from "../../../Drawers/SectionsAndLayoutsDrawer/SectionsAndLayouts";
import SectionsAndLayoutsSettings from "./components/SectionsAndLayoutsSettings";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
  availableOptions: FormAvailableFields[];
  prefill?: Prefill;
}

const BuildTab = ({ form, setForm, availableOptions, prefill }: Props) => {
  const collapseItems = [
    {
      key: "header",
      title: "Header",
      children: <Header form={form} setForm={setForm} />,
    },
    {
      key: "fields",
      title: "Fields",
      children: (
        <Fields
          form={form}
          setForm={setForm}
          availableOptions={availableOptions}
          prefill={prefill}
        />
      ),
    },
    {
      key: "hiddenFields",
      title: "Hidden Fields",
      children: (
        <HiddenFields
          form={form}
          setForm={setForm}
          availableOptions={availableOptions}
        />
      ),
    },
    {
      key: "sections",
      title: "Sections",
      children: <SectionsAndLayoutsSettings form={form} setForm={setForm} />,
    },
  ];

  return (
    <>
      {collapseItems.map((collapseItem) => {
        return (
          <CollapseItem
            title={collapseItem?.title}
            children={collapseItem?.children}
            key={collapseItem.key}
            defaultOpen={false}
          />
        );
      })}
    </>
  );
};

export default BuildTab;
